import { jsxs as d, jsx as i } from "@emotion/react/jsx-runtime";
import { Label as b } from "./InputLabel.styled.js";
import { Icon as f } from "../Icon/index.js";
import { Text as x } from "../Text/index.js";
const h = ({
  dataTrackId: n,
  edit: o,
  disabled: t,
  value: r,
  required: e,
  htmlFor: m,
  readOnly: p,
  hasOldTextFieldHeight: s,
  color: a = "secondary",
  className: c
}) => /* @__PURE__ */ d(b, { dataTrackId: n, edit: !!o, disabled: t, htmlFor: m, readOnly: p, hasOldTextFieldHeight: s, className: c, children: [
  typeof r == "string" ? /* @__PURE__ */ i(x, { variant: o ? "bodyXSSemibold" : "bodyMSemibold", as: "span", color: a, children: r }) : r,
  !!e && /* @__PURE__ */ i(f, { icon: ["fa-asterisk"], color: "danger", iconSize: o ? "8px" : "10px" })
] });
export {
  h as InputLabel
};
